import { z } from 'zod';

export const holdOrderSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, { error: 'orders:hold.validation.reasonRequired' })
    .max(500, { error: 'orders:hold.validation.reasonLength' }),
});

export type HoldOrderFormInput = z.input<typeof holdOrderSchema>;
export type HoldOrderFormOutput = z.output<typeof holdOrderSchema>;
